/* eslint-disable jira/filename-case */
export const DEFAULT_CACHE_MAX_LIMIT = 100;
export const DEFAULT_RESOURCE_BROWSER_ONLY = false;
export const DEFAULT_RESOURCE_SKIP_BROWSER = false;
export const DEFAULT_RESOURCE_MAX_AGE = 0;
export const DEFAULT_RESOURCE_IS_CRITICAL = false;
